import React, { useContext } from "react";
import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Divider,
  Button,
  Box,
  makeStyles,
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useHistory } from "react-router-dom";
import { UserContext } from "src/context/User";
import ButtonCircularProgress from "./ButtonCircularProgress";

const useStyles = makeStyles({
  customButton: {
    backgroundColor: "#b3daff !important",
    color: "black !important",
    "&:hover": {
      backgroundColor: "#195f94 !important",
      color: "white !important",
    },
    "& span": {
      color: "black !important",
    },
  },
});

export default function AlertDialog({
  title,
  desc,
  isLoading,
  productName,
  open,
  handleClose,
  productData,
  deleteProductHandler,
  deleteServiceHandler,
}) {
  const classes = useStyles();
  const history = useHistory();

  const auth = useContext(UserContext);

  const logoutHandler = () => {
    history.push("/");
    auth.userLogIn(false, null);
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("userType");
    window.localStorage.removeItem("walletName");
    window.location = "/";
    auth.disconnectWallet();
  };
  const ThemedHeaderIcon = ({ isConfirm = true }) => (
    <Box
      style={{
        width: 64,
        height: 64,
        borderRadius: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.1) 100%)",
        border: "1px solid rgba(255,255,255,0.35)",
        boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
      }}
    >
      {isConfirm ? (
        <CheckCircleIcon style={{ color: "#FFFFFF", fontSize: 34 }} />
      ) : (
        <WarningIcon style={{ color: "#FFFFFF", fontSize: 34 }} />
      )}
    </Box>
  );

  const PaperStyles = {
    background: "#FFFFFF",
    borderRadius: 16,
    boxShadow: "0 16px 40px rgba(0,0,0,0.22)",
    overflow: "hidden",
  };

  const HeaderStyles = {
    background: "linear-gradient(180deg, #1D649C 0%, #155A8A 100%)",
    padding: "16px 20px",
    display: "flex",
    alignItems: "center",
    gap: 12,
  };

  const TitleTextStyles = {
    color: "#FFFFFF",
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 1.2,
  };

  const ContentStyles = {
    padding: "18px 22px",
  };

  const DescStyles = {
    color: "#1A1A1A",
    fontSize: 14,
    lineHeight: 1.6,
    textAlign: "center",
  };

  const ActionsStyles = {
    padding: "12px 16px",
  };

  const CancelBtnStyles = {
    padding: "9px 18px",
    borderRadius: 10,
    border: "1px solid #D0D5DD",
    color: "black !important",
    background: "#b3daff !important",
    textTransform: "none",
  };

  const ConfirmBtnStyles = {
    marginLeft: 12,
    padding: "9px 18px",
    borderRadius: 10,
    background: "#b3daff !important",
    color: "black !important",
    textTransform: "none",
    boxShadow: "0 6px 14px rgba(29,100,156,0.35)",
  };

  return (
    <div>
      {title === "Logout" ? (
        <Dialog
          open={open}
          onClose={() => {
            if (!isLoading) {
              handleClose();
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
          PaperProps={{ style: PaperStyles }}
        >
          <DialogTitle disableTypography style={HeaderStyles}>
            <ThemedHeaderIcon isConfirm={false} />
            <Typography style={TitleTextStyles}>{title}</Typography>
          </DialogTitle>
          <Divider />
          <DialogContent style={ContentStyles}>
            <Typography variant="body1" style={DescStyles}>
              {desc}
            </Typography>
          </DialogContent>
          <Divider />
          <DialogActions style={ActionsStyles}>
            <Box width="100%" display="flex" justifyContent="flex-end" gap={16}>
              <Button 
                disabled={isLoading} 
                onClick={handleClose} 
                className={classes.customButton}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                disabled={isLoading}
                className={classes.customButton}
                variant="contained"
                onClick={logoutHandler}
                style={{ marginLeft: "16px" }}
              >
                Confirm {isLoading && <ButtonCircularProgress />}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      ) : (
        <Dialog
          open={open}
          onClose={() => {
            if (!isLoading) {
              handleClose();
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
          PaperProps={{ style: PaperStyles }}
        >
          <DialogTitle disableTypography style={HeaderStyles}>
            <ThemedHeaderIcon isConfirm={true} />
            <Typography style={TitleTextStyles}>{title}</Typography>
          </DialogTitle>
          <Divider />
          <DialogContent style={ContentStyles}>
            <Typography variant="body1" style={DescStyles}>
              {desc}
            </Typography>
          </DialogContent>
          <Divider />
          <DialogActions style={ActionsStyles}>
            <Box width="100%" display="flex" justifyContent="flex-end" gap={16}>
              <Button 
                disabled={isLoading} 
                onClick={handleClose} 
                className={classes.customButton}
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                disabled={isLoading}
                className={classes.customButton}
                variant="contained"
                onClick={() => {
                  if (productName === "Product") {
                    deleteProductHandler(productData?._id);
                  }
                  if (productName === "Service") {
                    deleteServiceHandler(productData?._id);
                  }
                }}
                style={{ marginLeft: "16px" }}
              >
                Confirm {isLoading && <ButtonCircularProgress />}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
